import { Component, OnInit } from '@angular/core';

/** Application side-menu shell — placeholder for future navigation tree; currently renders no data logic. */
@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css'],
})
export class SideMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
